var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLactoseFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#aa80e0",
    r: 256,
    style: {
      fill: "rgb(119, 187, 65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.83 511.16c-6.87.56-13.82.84-20.83.84-141.38 0-256-114.62-256-256 0-141.39 114.62-256 256-256 7.01 0 13.96.28 20.83.84-131.65 10.59-235.18 120.78-235.18 255.16 0 134.37 103.53 244.57 235.18 255.16z",
    fill: "#8b66c6",
    style: {
      fill: "rgb(102, 156, 53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.36 256c0 37.55-13.59 71.92-36.12 98.48-1.802 2.131-27.784-8.256-29.702-6.229-3.841 4.061 16.214 20.377 11.952 23.999-2.16 1.83-4.37 3.6-6.63 5.31-25.54 19.33-57.36-22.74-91.86-22.74-17.99 0-27.408 5.73-43.428 0-6.83-2.44 6.34 3.36 0 0-7.31-3.85-41.892 27.69-48.432 22.74-36.75-27.82-60.5-71.92-60.5-121.56 0-37.55 13.59-71.92 36.12-98.48 3.706-4.385 16.759 7.994 20.943 4.061 1.923-1.808-5.199-20.118-3.183-21.821 26.56-22.53 60.93-36.12 98.48-36.12 84.14 0 152.36 68.22 152.36 152.36z",
    fill: "#5b565f",
    style: {
      fill: "rgb(224, 237, 212)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m347.86 288.15v89.41c-6.54 4.95-13.5 9.38-20.8 13.23-21.22 11.22-45.4-25.068-71.06-25.068s-49.84 36.288-71.06 25.068c-7.3-3.85-14.26-8.28-20.8-13.23v-89.41c0-21.15 7.7-41.58 21.65-57.48h.01c13.95-15.9 21.65-36.34 21.65-57.49v-42.55h97.1v42.55c0 2.93.15 5.85.44 8.74 1.82 17.99 9.19 35.05 21.21 48.75h.01c13.95 15.9 21.65 36.33 21.65 57.48z",
    fill: "#bbe9fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.06 341.78v49.01c-21.22 11.22-45.4 17.57-71.06 17.57s-49.84-6.35-71.06-17.57v-83.76c0-7.46 4.81-14.09 11.92-16.35 2.64-.85 5.27-1.46 7.86-1.88 37.3-5.93 69.59 30.05 107.73 36.01 8.39 1.31 14.61 8.48 14.61 16.97z",
    fill: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.57 168.216h-93.14c-6.64 0-12.023-5.383-12.023-12.023v-19.023c0-6.64 5.383-12.023 12.023-12.023h93.141c6.64 0 12.023 5.383 12.023 12.023v19.023c0 6.64-5.383 12.023-12.024 12.023z",
    fill: "#bbe9fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.99 181.92h-62.09c-5.14 0-9.49 3.8-10.2 8.9-.61 4.45-1.47 8.83-2.54 13.07-2.48 9.75-6.13 18.83-10.84 26.78-9.41 15.9-14.6 36.33-14.6 57.48v91.125c-6.832-2.445-13.44 14.872-19.783 11.522-7.304-3.859-14.256-8.291-20.797-13.236v-89.41c0-21.15 7.7-41.58 21.65-57.48 6.98-7.95 12.39-17.03 16.07-26.78 3.66-9.74 5.59-20.13 5.59-30.71v-5.13c-5.7-.95-10.05-5.9-10.05-11.86v-19.02c0-6.64 5.39-12.02 12.03-12.02h33.01c-6.65 0-12.03 5.38-12.03 12.02v19.02c0 6.64 5.38 12.02 12.03 12.02h60.13c.67 0 1.33-.05 1.98-.16v5.13c0 2.929.15 5.849.44 8.739z",
    fill: "#89d5ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.72 288.8v110.71c-6.83-2.44-13.44-5.36-19.78-8.72v-83.76c0-7.46 4.81-14.09 11.92-16.35 2.64-.85 5.27-1.46 7.86-1.88z",
    fill: "#e3e1f2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m372.24 354.48c-5.41 6.4-11.36 12.34-17.75 17.77l-214.73-214.73c5.41-6.4 11.36-12.35 17.76-17.76z",
    fill: "#8b66c6",
    style: {
      fill: "rgb(102, 156, 53)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffce3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m153.28 107.04-45.78-22.45-10.85-5.32c-.07-.03-.14-.06-.2-.09-3.29-1.49-7.11-.86-9.74 1.62-2.62 2.47-3.49 6.24-2.2 9.61.03.06.05.12.07.17l6.07 14.76 17.95 43.64c1.2 2.9 3.99 4.65 6.94 4.65.95 0 1.92-.18 2.85-.56 3.83-1.58 5.66-5.96 4.09-9.79l-4.02-9.77 18.77-17.63 9.45 4.63c3.72 1.82 8.21.28 10.04-3.44 1.82-3.71.28-8.21-3.44-10.03zm-40.93 11.63-7.72-18.78 18.21 8.93z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.57 177.45c-10.08 18.37-10.41 18.78-10.91 19.41-1.47 1.82-3.64 2.8-5.85 2.8-1.24 0-2.49-.31-3.64-.94l-39.09-21.73-13.18-7.33c-3.63-2.01-4.93-6.57-2.92-10.19 2.02-3.63 6.58-4.93 10.2-2.92l11.02 6.12 34.74 19.31c1.88-3.39 4.26-7.71 6.48-11.75 1.99-3.63 6.55-4.96 10.18-2.97s4.96 6.55 2.97 10.19z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.508 159.97-12.041-21.899c-1.996-3.629-6.554-4.955-10.186-2.958l-25.986 14.288s0 0 0 0l-25.985 14.287c-1.743.958-3.034 2.57-3.589 4.48s-.328 3.963.63 5.706l12.041 21.899c1.366 2.484 3.932 3.888 6.579 3.888 1.221 0 2.46-.299 3.606-.929 3.63-1.996 4.955-6.556 2.959-10.186l-8.427-15.327 12.842-7.061 7.539 13.712c1.366 2.484 3.932 3.888 6.579 3.888 1.221 0 2.461-.299 3.607-.929 3.629-1.996 4.954-6.556 2.958-10.186l-7.539-13.712 12.842-7.061 8.427 15.327c1.996 3.629 6.555 4.955 10.186 2.958 3.629-1.995 4.954-6.555 2.958-10.185z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.3 74.3c-.22 1.52-.55 3.02-.99 4.47-2.21 7.39-7.09 13.59-14.11 17.91-6.1 3.77-12.88 5.56-19.58 5.56-12.57 0-24.85-6.31-31.92-17.77-8.64-14.02-6.9-31.56 3.08-43.57 2.53-3.05 5.59-5.75 9.14-7.94 4.14-2.55 8.67-4.25 13.37-5.05 2.56-.43 5.17-.6 7.8-.49 4.14.18 7.36 3.67 7.18 7.81-.17 4.14-3.66 7.36-7.8 7.18-4.48-.18-8.85.96-12.68 3.32-10.53 6.49-13.81 20.34-7.32 30.86 6.49 10.53 20.33 13.82 30.86 7.33 3.9-2.41 6.46-5.58 7.61-9.45.23-.75.4-1.54.52-2.34.6-4.1 4.41-6.94 8.51-6.34s6.93 4.41 6.33 8.51z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.595 14.804h-33.056c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h8.961v52.356c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-52.356h9.095c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.38 27.4c-20.63 0-37.42 16.79-37.42 37.43s16.79 37.43 37.42 37.43c20.64 0 37.43-16.79 37.43-37.43s-16.79-37.43-37.43-37.43zm0 59.86c-12.36 0-22.42-10.06-22.42-22.43s10.06-22.43 22.42-22.43c12.37 0 22.43 10.06 22.43 22.43s-10.06 22.43-22.43 22.43z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.601 107.997c-1.098-1.861-2.166-3.582-3.108-5.099-3.408-5.491-5.199-8.507-5.472-11.749-.117-1.397 1.015-2.386 1.507-2.746 1.738-1.271 4.218-1.434 6.635-.436 8.132 3.36 10.285 13.077 10.343 13.353.794 4.041 4.702 6.692 8.756 5.922 4.07-.771 6.743-4.696 5.972-8.766-.137-.726-3.55-17.846-19.343-24.372-7.291-3.012-15.222-2.193-21.217 2.19-5.282 3.863-8.124 9.885-7.601 16.11.587 6.985 3.871 12.277 7.674 18.404.922 1.486 1.909 3.074 2.933 4.811 1.419 2.405 4.35 8.316.932 11.252-2.572 2.209-7.906 2.313-12.381-1.338-4.605-3.758-7.522-9.231-7.803-14.639-.214-4.137-3.743-7.311-7.878-7.102-4.137.215-7.316 3.742-7.102 7.878.496 9.567 5.467 19.094 13.299 25.484 5.138 4.193 11.249 6.31 17.133 6.31 5.315 0 10.446-1.728 14.505-5.215 6.439-5.528 10.401-16.378 2.216-30.252z",
    fill: "#ffce3c",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8f6f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m190.92 417.84c-2.33 3.42-7 4.31-10.42 1.98l-15.81-10.76-9.69 14.24 14.06 9.57c3.43 2.33 4.32 6.99 1.99 10.42-1.46 2.13-3.81 3.28-6.21 3.28-1.46 0-2.92-.42-4.21-1.3l-14.07-9.57-11.99 17.64-2.61 3.83c-1.45 2.13-3.81 3.28-6.21 3.28-1.45 0-2.92-.42-4.21-1.3-3.42-2.33-4.31-6.99-1.98-10.42l3.65-5.36 33.29-48.94c1.12-1.65 2.85-2.78 4.8-3.15 1.96-.37 3.98.05 5.62 1.16l22.01 14.98c3.43 2.33 4.32 6.99 1.99 10.42z",
    fill: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.464 478.211-19.712 4.055-3.582-17.416 17.718-3.644c4.057-.834 6.669-4.8 5.835-8.857s-4.8-6.667-8.857-5.835l-17.717 3.644-3.582-17.416 19.712-4.055c4.057-.834 6.669-4.8 5.835-8.857-.834-4.058-4.799-6.668-8.857-5.835l-27.059 5.566c-1.948.401-3.658 1.559-4.752 3.22s-1.484 3.689-1.083 5.637l6.604 32.108s0 0 0 .001l6.604 32.108c.401 1.948 1.559 3.658 3.22 4.752 1.234.813 2.67 1.237 4.126 1.237.504 0 1.01-.051 1.511-.154l27.059-5.566c4.057-.834 6.669-4.8 5.835-8.857-.834-4.058-4.797-6.67-8.858-5.836z",
    fill: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.001 444.321c-2.639-3.192-7.367-3.641-10.559-1.002l-15.511 12.823-11.33-13.704 13.941-11.526c3.192-2.639 3.641-7.367 1.001-10.559-2.638-3.192-7.366-3.641-10.559-1.002l-13.941 11.526-11.33-13.704 15.511-12.823c3.192-2.639 3.641-7.367 1.001-10.559-2.639-3.192-7.366-3.641-10.559-1.002l-21.292 17.602c-1.533 1.268-2.5 3.092-2.688 5.072s.418 3.954 1.686 5.487l41.774 50.53c1.483 1.794 3.625 2.721 5.785 2.721 1.683 0 3.376-.564 4.774-1.72l21.295-17.601c3.192-2.639 3.641-7.367 1.001-10.559z",
    fill: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.95 430.82c-3.31-5.77-8.66-10.03-15.06-11.99l-16.82-5.14c-1.9-.58-3.95-.38-5.71.55-1.76.94-3.07 2.53-3.65 4.44l-10.07 32.96-9.26 30.31c-.43 1.4-.43 2.83-.07 4.14.65 2.41 2.49 4.44 5.05 5.23.73.22 1.47.33 2.19.33 1.13 0 2.23-.26 3.22-.73 1.84-.87 3.32-2.48 3.96-4.58l6.06-19.85 14.12 31.19c.6 1.31 1.53 2.38 2.64 3.12 1.23.84 2.7 1.29 4.2 1.29h.14c.98-.02 1.99-.23 2.95-.67 3.77-1.71 5.45-6.15 3.74-9.92l-11.02-24.33c.55.04 1.1.06 1.65.06 10.85 0 20.79-6.74 24.01-17.28 1.95-6.38 1.14-13.17-2.27-19.13zm-12.07 14.75c-1.54 5.02-7.51 7.84-13.04 6.15-2.22-.68-6.15-1.86-9.65-2.91l5.67-18.58 9.65 2.95c2.7.82 5.04 2.68 6.43 5.1 1.33 2.32 1.66 4.91.94 7.29z",
    fill: "#f8f6f7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8f6f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m479.128 250.116-18.741-18.741c-1.567-1.567-4.107-1.567-5.674 0l-18.741 18.741c-11.917 11.917-11.917 31.239 0 43.157 11.917 11.917 31.239 11.917 43.157 0 11.917-11.918 11.917-31.24-.001-43.157z",
    fill: "#f8f6f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.97 271.69c0 7.81-2.98 15.62-8.94 21.58s-13.77 8.94-21.58 8.94c-2.99 0-5.98-.44-8.87-1.32-4.65-1.4-9.03-3.94-12.71-7.62-11.92-11.92-11.92-31.24 0-43.15l9.22-9.23 9.52-9.52c1.57-1.56 4.11-1.56 5.68 0l18.74 18.75c5.96 5.96 8.94 13.76 8.94 21.57z",
    fill: "#f8f6f7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m48.18 156.55 11.02 6.12c-1.85 4.71-3.56 9.48-5.12 14.32l-13.18-7.33c-3.63-2.01-4.93-6.57-2.92-10.19 2.02-3.63 6.58-4.93 10.2-2.92z",
    fill: "#ffbf03",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.65 79.27 10.85 5.32c-5.96 6.61-11.59 13.54-16.85 20.75l-6.07-14.76c-.02-.05-.04-.11-.07-.17-1.29-3.37-.42-7.14 2.2-9.61 2.63-2.48 6.45-3.11 9.74-1.62.06.03.13.06.2.09z",
    fill: "#ffbf03",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.29 27.91c-7.74 3.96-15.25 8.3-22.51 12.99 2.53-3.05 5.59-5.75 9.14-7.94 4.14-2.55 8.67-4.25 13.37-5.05z",
    fill: "#ffbf03",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#d7d6e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.65 256c0 15.31 1.34 30.32 3.93 44.89-4.65-1.4-9.03-3.94-12.71-7.62-11.92-11.92-11.92-31.24 0-43.15l9.22-9.23c-.29 5-.44 10.04-.44 15.11z",
    fill: "#d7d6e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.21 443.37c3.69 3.43 7.47 6.76 11.36 9.97l-2.61 3.83c-1.45 2.13-3.81 3.28-6.21 3.28-1.45 0-2.92-.42-4.21-1.3-3.42-2.33-4.31-6.99-1.98-10.42z",
    fill: "#d7d6e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.31 486.09c3.44 1.69 6.93 3.3 10.46 4.83-.99.47-2.09.73-3.22.73-.72 0-1.46-.11-2.19-.33-2.56-.79-4.4-2.82-5.05-5.23z",
    fill: "#d7d6e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.89 502.09h-.14c-1.5 0-2.97-.45-4.2-1.29 1.44.44 2.89.87 4.34 1.29z",
    fill: "#d7d6e5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLactoseFree);
export default __webpack_public_path__ + "static/media/lactoseFree.d625b4b6c825b1cb49eafa36527751d5.svg";
export { ForwardRef as ReactComponent };